import { Box, FormControl, FormLabel, Input, Stack } from "@chakra-ui/react";
import React, { memo, useCallback } from "react";
import { useForm } from "react-hook-form";
import { NodeProps } from "reactflow";
import { useUpdateNodeData } from "../../../hooks/useUpdateNodeData";
import { NodeType } from "../../../models/nodeType";
import PlayerSelect from "../../base/PlayerSelect";
import JSONSchemaEditor from "../JSONSchemaEditor";
import { BaseNodeWithChildren } from "./base/BaseNode";

interface PlayerKeyValueFindData {
  userId: string;
  key: string;
  outputSchema: string;
}

const PlayerKeyValueFindNode: React.FC<NodeProps<NodeType<PlayerKeyValueFindData>>> = (props) => {
  const {
    id: nodeId,
    data: { color, nodeData },
  } = props;

  const userId = nodeData?.userId ?? "";
  const key = nodeData?.key ?? "";
  const outputSchema = nodeData?.outputSchema ?? "";

  const { control, register, handleSubmit, setValue } = useForm<PlayerKeyValueFindData>({
    defaultValues: {
      userId,
      key,
      outputSchema,
    },
  });

  const { updateNodeData } = useUpdateNodeData(nodeId);

  const handleUpdate = useCallback((sessionStatus: PlayerKeyValueFindData) => {
    updateNodeData(sessionStatus);
  }, []);

  return (
    <BaseNodeWithChildren {...props}>
      <FormControl
        className={"nodrag"}
        onSubmit={handleSubmit(handleUpdate)}
        onBlur={handleSubmit(handleUpdate)}
        onChange={handleSubmit(handleUpdate)}
      >
        <PlayerSelect control={control} color={color} />
        <Stack>
          <Box py={1} w="25rem">
            <FormLabel textTransform={"uppercase"} color={color}>
              Key
            </FormLabel>
            <Input type={"text"} placeholder="key" {...register("key")} />
          </Box>
          <Box py={1}>
            <FormLabel textTransform={"uppercase"} color={color}>
              Output Schema
            </FormLabel>
            <JSONSchemaEditor name="outputSchema" control={control} height="25vh" />
          </Box>
        </Stack>
      </FormControl>
    </BaseNodeWithChildren>
  );
};

export default memo(PlayerKeyValueFindNode);
